import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { buildLoginUrlWithRedirect } from 'services/authRedirect';

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const location = useLocation();
  const isAuth = localStorage.getItem('isAuthenticated');

  if (isAuth !== JSON.stringify(true)) {
    const loginUrl = buildLoginUrlWithRedirect(location.pathname, location.search);
    return <Navigate to={loginUrl} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
